import { Controller } from "@hotwired/stimulus"

// Drop target for the CSV import: dropping a file anywhere on the page (or choosing one) sends it
// straight to the preview.
export default class extends Controller {
  static targets = ["input", "zone", "label"]

  highlight(event) {
    if (!this.carriesFiles(event)) return

    event.preventDefault()
    this.zoneTarget.toggleAttribute("data-active", true)
  }

  unhighlight(event) {
    // Leaving one element for another fires dragleave too; only clear once the drag leaves the window
    if (event.relatedTarget) return

    this.zoneTarget.removeAttribute("data-active")
  }

  drop(event) {
    if (!this.carriesFiles(event)) return

    event.preventDefault()
    this.zoneTarget.removeAttribute("data-active")
    this.inputTarget.files = event.dataTransfer.files
    this.submit()
  }

  submit() {
    const file = this.inputTarget.files[0]
    if (!file) return

    this.labelTarget.textContent = `Checking ${file.name}…`
    this.element.requestSubmit()
  }

  carriesFiles(event) {
    return [...(event.dataTransfer?.types || [])].includes("Files")
  }
}
